import React from 'react';
import styled from 'styled-components/macro';
import { NavLink } from 'react-router-dom';
import { faCaretRight } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

type Blog = {
  content: string;
  image?: string;
  path: string;
  title: string;
};

type Props = {
  blog?: Blog;
  className?: string;
  title?: string;
};

const defaultBlog: Blog = {
  content: '',
  image: undefined,
  path: '',
  title: '',
};

export const RecentBlogSection = (props: Props) => {
  const { blog = defaultBlog, className = '', title = '' } = props;

  const sliceIndex = blog.content.length > 420 ? blog.content.lastIndexOf(' ', 420) : blog.content.length;
  const blogContent = blog.content.slice(0, sliceIndex);

  return (
    <StyledRecentBlogSection className={`${className} recent-blog`}>
      <section className="container">
        {title && <Title>{title}</Title>}
        <Post>
          <PostTitle to={blog.path}>{blog.title}</PostTitle>
          <Message>
            {blog.image && (
              <NavLink to={blog.path}>
                <img src={blog.image} alt="" />
              </NavLink>
            )}
            <p>
              <span
                dangerouslySetInnerHTML={{ __html: blogContent }} // eslint-disable-line react/no-danger
              />
              ...
              <MoreLink to={blog.path}>more...</MoreLink>
            </p>
            <div className="clear" />
          </Message>
          <ReadMoreButton to={blog.path} className="btn btn-primary">
            Read full post
            <ReadMoreIcon icon={faCaretRight} />
          </ReadMoreButton>
        </Post>
      </section>
    </StyledRecentBlogSection>
  );
};

const StyledRecentBlogSection = styled.div`
  background-color: ${(props) => props.theme.splashOptional1 || props.theme.splashPrimary2};
  padding: 12px;
`;

const Title = styled.div`
  color: ${(props) => props.theme.splashPrimary1};
  background-color: ${(props) => props.theme.primary9};
  display: inline-block;
  font-size: 1.7rem;
  padding: 12px 24px;
  text-transform: uppercase;
`;

const Post = styled.div`
  border: 1px solid ${(props) => props.theme.primary9};
  background-color: ${(props) => props.theme.splashPrimary1};
  padding: 0 16px 16px;
  position: relative;
`;

const PostTitle = styled(NavLink)`
  color: ${(props) => props.theme.primary10};
  font-size: 1.7rem;
  padding: 12px 0;
  text-transform: uppercase;
  display: block;
`;

const Message = styled.div`
  display: block;

  img {
    float: left;
    margin-right: 12px;
    max-width: 200px;
  }

  p {
    padding-bottom: 36px;
  }
`;

const MoreLink = styled(NavLink)`
  color: ${(props) => props.theme.primary9};
  margin-left: 8px;
`;

const ReadMoreButton = styled(NavLink)`
  bottom: 8px;
  color: ${(props) => props.theme.splashPrimary1};
  display: inline-block;
  margin: 0 24px;
  padding: 12px;
  position: absolute;
  right: 0;
`;

const ReadMoreIcon = styled(FontAwesomeIcon)`
  margin: 0 8px;
`;
